export const defaultListWithPagination = {
  payload: [],
  pagination_data: {
    page: 0,
    pages: 0,
    size: 0,
    total: 0
  }
}